module.exports = __webpack_public_path__ + "static/media/29.a59af5ea.svg";